/**
 * Four list states — shared HTML fragments (vanilla PWA).
 * Never surface raw exception strings in the error UI.
 */

export type ListEmptyAction = {
  label: string;
  /** data-attribute name for the primary action button, e.g. data-empty-action */
  dataAttr?: string;
};

export function listSkeletonHtml(rows = 4, rowClass = 'list-skel-row'): string {
  const bits: string[] = [];
  for (let i = 0; i < rows; i++) {
    bits.push(`<div class="${rowClass}" aria-hidden="true"></div>`);
  }
  return `<div class="list-state list-loading" role="status" aria-label="Loading">${bits.join('')}</div>`;
}

export function listEmptyHtml(
  message: string,
  action?: ListEmptyAction,
): string {
  const btn = action
    ? `<button type="button" class="btn-primary" ${action.dataAttr ?? 'data-empty-action'}>${escapeHtml(action.label)}</button>`
    : '';
  return `<div class="list-state list-empty">
    <p class="today-empty">${escapeHtml(message)}</p>
    ${btn}
  </div>`;
}

export function listErrorHtml(message = 'Couldn’t load this list. Check your connection and try again.'): string {
  return `<div class="list-state list-error" role="alert">
    <p>${escapeHtml(message)}</p>
    <button type="button" class="btn-secondary" data-list-retry>Try again</button>
  </div>`;
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
